import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {BdpkObject} from '../../bdpk-objects/domain/bdpk-object';
import {DxUserPrivilege} from "../../dx-auth/domain/user/dx-user-privilege";


@jsonObject
export class BdpkFolder {

  /** ID Задачи **/
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _parentId: number;

  /** Название задачи **/
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _name: string;

  /** Порядок */
  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _ord: number;

  @jsonMember({name: "analyticalTaskId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _analyticalTaskId: number;

  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  @jsonMember({name: "isVisible", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isVisible: boolean;

  @jsonMember({name: "imagePath", constructor: String, emitDefaultValue: false, isRequired: false })
  private _imagePath: string;

  @jsonArrayMember(Number, {emitDefaultValue: false, preserveNull: false, isRequired: false})
  privileges: number[] = [];

  @jsonArrayMember(BdpkObject, {name: "objects", emitDefaultValue: false, isRequired: false})
  private _objects: BdpkObject[] = [];


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get parentId(): number {
    return this._parentId;
  }

  set parentId(value: number) {
    this._parentId = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get analyticalTaskId(): number {
    return this._analyticalTaskId;
  }

  set analyticalTaskId(value: number) {
    this._analyticalTaskId = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  set isVisible(value: boolean) {
    this._isVisible = value;
  }

  get imagePath(): string {
    return this._imagePath;
  }

  set imagePath(value: string) {
    this._imagePath = value;
  }

  get objects(): BdpkObject[] {
    return this._objects;
  }

  set objects(value: BdpkObject[]) {
    this._objects = value;
  }
}
